import {
  CellStyleModule,
  ClientSideRowModelApiModule,
  ClientSideRowModelModule,
  ColumnApiModule,
  CustomFilterModule,
  DateFilterModule,
  InfiniteRowModelModule,
  LocaleModule,
  Module,
  ModuleRegistry,
  NumberFilterModule,
  PaginationModule,
  PinnedRowModule,
  provideGlobalGridOptions,
  RenderApiModule,
  RowApiModule,
  RowSelectionModule,
  RowStyleModule,
  TextFilterModule,
  themeAlpine,
  TooltipModule,
  ValidationModule
} from 'ag-grid-community'
import {
  ColumnsToolPanelModule,
  ContextMenuModule,
  GroupFilterModule,
  MasterDetailModule,
  MultiFilterModule,
  NewFiltersToolPanelModule,
  PivotModule,
  RowGroupingModule,
  RowGroupingPanelModule,
  ServerSideRowModelApiModule,
  ServerSideRowModelModule,
  SetFilterModule,
  SideBarModule,
  TreeDataModule
} from 'ag-grid-enterprise'

let registered = false

export function registerAgGridModules(): void {
  if (registered) return
  registered = true

  const communityModules: Module[] = [
    CellStyleModule,
    ClientSideRowModelModule,
    ClientSideRowModelApiModule,
    ColumnApiModule,
    CustomFilterModule,
    DateFilterModule,
    InfiniteRowModelModule,
    LocaleModule,
    NumberFilterModule,
    PaginationModule,
    PinnedRowModule,
    RenderApiModule,
    RowApiModule,
    RowSelectionModule,
    RowStyleModule,
    TextFilterModule,
    TooltipModule
  ]
  const enterpriseModules: Module[] = [
    ColumnsToolPanelModule,
    ContextMenuModule,
    GroupFilterModule,
    MasterDetailModule,
    MultiFilterModule,
    NewFiltersToolPanelModule,
    PivotModule,
    RowGroupingModule,
    RowGroupingPanelModule,
    ServerSideRowModelApiModule,
    ServerSideRowModelModule,
    SetFilterModule,
    SideBarModule,
    TreeDataModule
  ]
  if (process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT !== 'prod') {
    communityModules.push(ValidationModule)
  }
  ModuleRegistry.registerModules([...communityModules, ...enterpriseModules])
  provideGlobalGridOptions({ theme: themeAlpine })
}
